export const SET_TITLE = 'SET_TITLE'

export interface SetTitle {
  type: typeof SET_TITLE
  payload: string
}

export interface HeaderState {
  title: string | null
}

export const initialState: HeaderState = {
  title: null,
}

export type HeaderActions = SetTitle
